import { Rpc } from "./rpc";

export class UsersRpc {

    public static list(): Promise<UserListResponse> {
        return Rpc.GET("/rpc/users/list");
    }

    private constructor() {}

}

export interface UserListResponse {

    readonly users: UserListItem[];

}

export interface UserListItem {

    readonly id: number;
    readonly teamId?: number;
    readonly email: string;
    readonly visibleName: string;
    readonly position: string;
    readonly bio: string;
    readonly chatAddress: string;
    readonly homePhone: string;
    readonly workPhone: string;
    readonly address: string;
    readonly memberSince: string;

}